import { PORTAL_CONSTANT } from "~/constant/site/portal/portalConstant.js";

// 사용법
// vue나 js에서 this.$constant.PAGE_DISPLAY_COUNT
export default (context, inject) => {

	inject( "constant", PORTAL_CONSTANT )

};
